import React from 'react'
import { useFileSelectionForClaimProcedure } from '@context/FileSelectionForClaimProcedureContext'
import Files from '@pages/Files/Files.page'
import './FileSelectionOverlay.css'

const FileSelectionOverlay: React.FC = () => {
  const { isOpen, close, confirmSelection } =
    useFileSelectionForClaimProcedure()

  if (!isOpen) return null

  return (
    <div className="file-selection-overlay">
      <div className="file-selection-overlay-content">
        <Files
          selectionMode
          onFilesSelected={confirmSelection}
          onSelectionCancel={close}
        />
      </div>
    </div>
  )
}

export default FileSelectionOverlay
